<div id="telephone-directory" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Telephone Directory</h2>
    <p class="inner-lead mt-3">
      For any queries, you can contact the college administration and departments through the following telephone
      numbers.
    </p>

    <div class="table-responsive-inner mt-4">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Office / Department</th>
            <th>Contact Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>General Enquiry</td>
            <td>+91 9729458602</td>
          </tr>
          <tr>
            <td>Administrative Office</td>
            <td>+91 9053338602</td>
          </tr>
          <!-- <tr>
            <td>College Reception</td>
            <td>01666 238602</td>
          </tr> -->
        </tbody>
      </table>
    </div>

    <hr class="divider">
    <div class="pdf-section mt-5">
      <h3 class="section-subtitle">Teaching & Non-Teaching Staff Contact Directory</h3>
      <p class="inner-lead mt-3">
        For detailed contact numbers of our Teaching and Non-Teaching staff members, please refer to the directory
        below.
      </p>

      <div class="pdf-block mt-4">
        <pdf-viewer src="/assets/pdf/Contact Details of of Teaching & Non Teaching Staff.pdf" [render-text]="true"
          [original-size]="false" style="width: 100%; height: 750px; display: block;">
        </pdf-viewer>
      </div>

      <div class="mt-4 text-center">
        <a href="/assets/pdf/Contact Details of of Teaching & Non Teaching Staff.pdf" target="_blank"
          class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> View / Download Staff Contact Details (PDF)
        </a>
      </div>
    </div>
  </div>
</div>